import { Neo } from "@singularsystems/neo-react";
import { NeoReport, Report } from "@singularsystems/neo-reporting";
import { ReportCategory } from "../ReportCategory";
import IssuerInvestmentAccrualScheduleReportCriteria from "./IssuerInvestmentAccrualScheduleReportCriteria";
import IssuerInvestmentAutoComplete from "../../../Domain/Components/IssuerInvestmentAutoComplete";
import AccrualScheduleHelper from "./AccrualScheduleHelper";

@NeoReport("IssuerInvestmentAccrualScheduleReport", { category: ReportCategory.IssuerReports })
export default class IssuerInvestmentAccrualScheduleReport extends Report<IssuerInvestmentAccrualScheduleReportCriteria> {

    constructor() {
        super(IssuerInvestmentAccrualScheduleReportCriteria);
    }

    public renderCriteria() {

        return <div>
            <Neo.FormGroup>
                <IssuerInvestmentAutoComplete
                    bind={this.criteria.meta.issuerInvestmentId}
                    bindDisplay={this.criteria.meta.issuerInvestmentName}
                    useParentCache={false} />
            </Neo.FormGroup>
        </div>;
    }

    public getDefaultGridLayout(criteria?: IssuerInvestmentAccrualScheduleReportCriteria | undefined, propertyKey?: string | undefined) {
        return AccrualScheduleHelper.getLayout();
    }
}